(function () {
  if (customElements.get('ce-cart-drawer-observer') !== undefined) {
    return;
  }

  class CartDrawerObserver extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        scrollRoot: '[data-cart-drawer-observer-scroll-root]',
        scrollMarker: '[data-cart-drawer-observer-scroll-marker]',
        footer: '[data-cart-drawer-observer-footer]',
      };

      this.elements = null;

      this.resizeObserver = null;
      this.intersectionObserver = null;
    }

    parsedCallback() {
      this.elements = {
        scrollRoot: this.querySelector(this.selectors.scrollRoot),
        scrollMarker: this.querySelector(this.selectors.scrollMarker),
        footer: this.querySelector(this.selectors.footer),
      };

      this.initResizeObserver();
    }

    disconnectedCallback() {
      this.intersectionObserver.disconnect();
      this.resizeObserver.disconnect();
    }

    initResizeObserver() {
      const callback = (entries) => {
        for (let entry of entries) {
          this.initIntersectionObserver(entry.contentRect.height);
        }
      };

      this.resizeObserver = new ResizeObserver(callback);
      this.resizeObserver.observe(this.elements.footer);
    }

    initIntersectionObserver(height) {
      this.intersectionObserver?.disconnect();

      const callback = (entries) => {
        for (let entry of entries) {
          if (entry.isIntersecting) {
            requestAnimationFrame(() => {
              this.elements.footer.style.boxShadow = 'none';
            });
          } else {
            requestAnimationFrame(() => {
              this.elements.footer.style.boxShadow = '0 0 3px 1px rgb(0 0 0 / 0.25)';
            });
          }
        }
      };

      const options = {
        root: this.elements.scrollRoot,
        rootMargin: `0px 0px -${height + 32}px 0px`,
        threshold: 1.0,
      };

      this.intersectionObserver = new IntersectionObserver(callback, options);
      this.intersectionObserver.observe(this.elements.scrollMarker);
    }
  }

  customElements.define('ce-cart-drawer-observer', CartDrawerObserver);
})();
